import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { Iterable } from "../Utils/ObjUtils";
import { Guid } from "../Utils/Guid";
import { List } from "../Utils/List";
import { ValueEncoder } from "../Utils/ValueEncoder";

export class ProtocolSettingsSet implements ObjectSerializer, Iterable<Guid> {

	private _SettingsIDs: List<Guid>;

	constructor(other?: ProtocolSettingsSet) {
		this._SettingsIDs = new List<Guid>();

		if (other) {
			other._SettingsIDs.ForEach((id: Guid) => this._SettingsIDs.Add(id), this);
		}
	}

	public get Count(): number {
		return this._SettingsIDs.Count;
	}

	public Clear(): void {
		this._SettingsIDs.Clear();
	}

	public Contains(guid: Guid): boolean {
		return this._SettingsIDs.Contains(guid);
	}

	public AddProtoSettingsID(guid: Guid): void {
		if (!this._SettingsIDs.Contains(guid))
			this._SettingsIDs.Add(guid);
	}

	public RemoveProtoSettingsID(guid: Guid): void {
		this._SettingsIDs.Remove(guid);
	}

	public ForEach(callbackfn: (val: Guid, index: number, arr: Guid[]) => void, thisArg?: any): void {
		return this._SettingsIDs.ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (val: Guid, index: number, arr: Guid[]) => boolean, thisArg?: any): boolean {
		return this._SettingsIDs.Some(callbackfn, thisArg);
	}

	public Every(callbackfn: (val: Guid, index: number, arr: Guid[]) => boolean, thisArg?: any): boolean {
		return this._SettingsIDs.Every(callbackfn, thisArg);
	}

	public Equals(obj: any): boolean {
		if (!obj)
			return false;

		if (!(obj instanceof ProtocolSettingsSet))
			return false;
		let other = (obj as ProtocolSettingsSet);

		if (this._SettingsIDs.Count != other._SettingsIDs.Count)
			return false;

		for (let i = 0; i < this._SettingsIDs.Count; ++i) {
			let guid: Guid = this._SettingsIDs.Get(i);
			if (!other._SettingsIDs.Contains(guid))
				return false;
		}

		return true;
	}

	public toString(): string {
		let result = "";

		this._SettingsIDs.ForEach((value: Guid, index: number) => {
			if (index > 0)
				result += ",";
			result += ValueEncoder.EncodeGuid(value);
		});

		return result;
	}

	public ToString(): string {
		return this.toString();
	}

	public FromString(guidSetStr: string): boolean {
		var guids = new List<Guid>();

		if (guidSetStr) {
			let idStrArray: string[] = guidSetStr.split(',');

			idStrArray.forEach((value: string) => {
				let guidStr = value.trim();
				try {
					let guid = new Guid(guidStr);
					guids.Add(guid);
				}
				catch (err) {
					return false;
				}
			});
		}

		this._SettingsIDs.Clear();
		guids.ForEach((guid: Guid) => {
			this._SettingsIDs.Add(guid);
		}, this);
		console.assert(this._SettingsIDs.Count == guids.Count);

		return true;
	}

	public Write(obj: any, context: any): void {
		obj.protocol_settings_set = this.ToString();
	}

	public Read(obj: any, context: any): void {

		if (obj.protocol_settings_set === undefined ||
			typeof obj.protocol_settings_set !== "string") {
			throw new Error();
		}

		if (!this.FromString(obj.protocol_settings_set))
			throw new Error();
	}

}
